import forumNav from '@/forumcomponents/forumNav'
import miniNav from '@/forumViews/news/miniNav/miniNav'
export const news = [
	{
		path: '/forum/news',
		name: '_forumNews',
		component: forumNav,
		children: [
			{
				path: '/forum/news',
				redirect: '/forum/news/list',
				component: miniNav,
				children: [
					{
						path: '/forum/news/list',
						component: () => import('@/forumViews/news/list'),
                    },
					{
						path: '/forum/news/lastest',  
						component: () => import('@/forumViews/news/lastest'),
                    } ,
					{
						path: '/forum/news/detail',  
						component: () => import('@/forumViews/news/detail'),
                    } 
				],
            }
		],
	},
]
